import { ApiBase } from '@/api/methods/ApiBase'
import {
  ApiResponseCurriculumUnits,
  ApiResponseCurriculumUnitProblems,
} from '@/api/responses/proofread/curriculumUnits'

export namespace CurriculumUnitsApi {
  /**
   * 単元一覧取得
   *
   * @param gradeCode 学年コード
   * @param subjectCode 教科コード
   * @returns 単元一覧
   */
  export async function getCurriculumUnits(
    gradeCode: string,
    subjectCode: string
  ): Promise<ApiResponseCurriculumUnits> {
    const params = {
      gradeCode: gradeCode,
      subjectCode: subjectCode,
    }
    return await ApiBase.get('/proofread/curriculumUnits', params)
  }

  /**
   * 単元内の小問一覧取得
   *
   * @param curriculumUnitId 単元ID
   * @returns 小問一覧
   */
  export async function getCurriculumUnitProblems(
    curriculumUnitId: number
  ): Promise<ApiResponseCurriculumUnitProblems> {
    return await ApiBase.get(`/proofread/curriculumUnits/${curriculumUnitId}/problems`)
  }
}
